/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';

import Link from 'shared/components/presentational/CustomLink/CustomLink';
import BaseModal from 'shared/components/presentational/Modal/BaseModal';
import Picture from 'shared/components/presentational/Picture';
import { formatLegacyProgramUrl } from 'shared/blocks/tv-guide/helpers/index';
import { PROGRAM_TIME_FORMAT } from 'shared/blocks/tv-guide/constants';
import { FONT_FAMILIES, FONT_WEIGHTS } from 'shared/constants/theme';

const Wrapper = styled.div`
  background-color: ${props => props.theme.tvGuide.modal.background};
  max-width: 500px;
`;

const ProgramsWrapper = styled.div`
  padding: 20px 40px 20px 40px;
`;

const PictureWrapper = styled.div`
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
  width: 105px;
  margin: auto;
`;

const Program = styled(Link)`
  display: flex;
  margin: 0 40px 20px 40px;
`;
const Hour = styled.p`
  margin-top: 0;
  font-family: ${FONT_FAMILIES.base};
`;

const Description = styled.div`
  padding-left: 50px;
`;

const Title = styled.p`
  margin-top: 0;
  margin-bottom: 5px;
  font-family: ${FONT_FAMILIES.base};
  font-weight: ${FONT_WEIGHTS.bold};
`;
const Subtitle = styled.p`
  color: ${props => props.theme.tvGuide.modal.subtitle.color};
  font-family: ${FONT_FAMILIES.base};
`;

// eslint-disable-next-line react/prefer-stateless-function
class ModalProgram extends React.PureComponent {
  render() {
    const {
      onCloseRequest,
      channel,
      programs,
      timezone,
      urlPattern
    } = this.props;
    const isOpen = true;
    return (
      <BaseModal
        modalProps={{
          isOpen,
          onCloseRequest
        }}
      >
        <Wrapper>
          <PictureWrapper>
            <Picture
              alt="channel"
              url={channel.LogoUrl}
              width={105}
              height={59}
            />
          </PictureWrapper>
          <ProgramsWrapper>
            {programs.map((program, index) => (
              <Program
                key={`${index}-${program.startTime}`}
                to={formatLegacyProgramUrl(urlPattern, program)}
              >
                <Hour>
                  {dayjs
                    .unix(program.startTime)
                    .tz(timezone)
                    .format(PROGRAM_TIME_FORMAT)}
                </Hour>
                <Description>
                  <Title>{program.title}</Title>
                  <Subtitle>{program.subtitle}</Subtitle>
                </Description>
              </Program>
            ))}
          </ProgramsWrapper>
        </Wrapper>
      </BaseModal>
    );
  }
}

ModalProgram.displayName = 'ModalProgram';

export default ModalProgram;
